import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'alarmDate', fieldTitle: t('Ημερομηνία Alarm'), fieldType: 'DATE' },
    { fieldName: 'alarmType.name', fieldTitle: t('Κατηγορία'), fieldType: 'TEXT' },
    { fieldName: 'alarmType.description', fieldTitle: t('Μήνυμα'), fieldType: 'TEXT' },
    { fieldName: 'idoc.identificationDocument', fieldTitle: t('Κωδικός Εντύπου Αναγνώρισης'), fieldType: 'TEXT' },
    { fieldName: 'idocId', fieldTitle: t('Έντυπο Αναγνώρισης'), fieldType: 'TEXT' },
    { fieldName: 'collector.name', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    return useLazyQuery(gqlGetQuery);
    //return [null, { loading: null, data: null }];
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Alarms',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}

